import { reactive, toRefs } from 'vue'
import { queryDeliveryRelation } from '@/services/api/goods'
import { defineStore } from '../store'

export const useDeliveryRelationStore = defineStore(() => {
    const state = reactive({
        loading: false,
        deliveryRelationList: <Model.DeliveryRelationRsp[]>[], // 商品交割关系列表
    })

    const getDeliveryRelation = async () => {
        try {
            state.loading = true
            const res = await queryDeliveryRelation()
            state.deliveryRelationList = res.data
        } finally {
            state.loading = false
        }
    }

    const getDeliveryRelationByGoodsId = (goodsid: number) => {
        return state.deliveryRelationList.find((e) => e.goodsid === goodsid)
    }

    return {
        ...toRefs(state),
        getDeliveryRelation,
        getDeliveryRelationByGoodsId,
    }
})